import { capitalizeFirstLetter } from 'utils/capitalize-first-letter';

/**
 * Simple mappings from name --> definition
 */
const FIELD_DISPLAY_MAP: Record<string, PreviewField> = {
  virtual_account_number: {
    label: 'Account',
    kind: 'virtual_account'
  },
  country_code: {
    label: 'Country',
    kind: 'country'
  },
  amount: {
    label: 'Amount',
    kind: 'amount'
  },
  iban: {
    label: 'IBAN',
    kind: 'iban'
  },
  business_unit: {
    label: 'Business Unit',
    kind: 'business_unit'
  }
};

/**
 * Used to discriminate the field to select the display type
 */
export const enhanceFieldPreview = (
  field: string,
  value: string
): Previewable => {
  const displayField =
    field in FIELD_DISPLAY_MAP
      ? FIELD_DISPLAY_MAP[field]
      : getDefaultFieldPreview(field);

  return {
    ...displayField,
    value
  };
};

export const textFieldPreview = (field: string): Previewable => {
  const enhanced = enhanceFieldPreview(field, '-');

  return {
    ...enhanced,
    kind: 'text'
  };
};

/**
 * Base display
 */
const getDefaultFieldPreview = (field: string): PreviewField => {
  return {
    label: field.split('_').map(capitalizeFirstLetter).join(' '),
    kind: 'text'
  };
};

/**
 * Preview types used by factory
 */
type PreviewTypes =
  | 'text'
  | 'date'
  | 'virtual_account'
  | 'country'
  | 'iban'
  | 'business_unit'
  | 'amount';

/**
 * Previewable field
 */
type PreviewField = {
  label: string;
  kind: PreviewTypes;
};

/**
 * Preview type
 */
export type Previewable = {
  label: string;
  kind: PreviewTypes;
  value: string;
};
